<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-select filterable v-model="queryForm.typehood" placeholder="订单类型" clearable>
              <el-option v-for="item in typehoods" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="订单号/订单标题/姓名/手机号"
            />
          </el-form-item>
          <el-form-item label="">
            <el-select filterable v-model="queryForm.step" placeholder="订单状态" clearable>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select filterable v-model="queryForm.channel" placeholder="支付类型" clearable class="mr-10">
              <el-option v-for="item in channels" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        width="250"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="订单类型"
        show-overflow-tooltip
      >
        <template #default="{ row }">
           {{ typehoods.find(e => e.value == row.typehood)&&typehoods.find(e => e.value == row.typehood).label }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="订单金额"
        show-overflow-tooltip
      >
        <template #default="{ row }">
           {{ row.amount && row.amount && row.amount.payAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="退款金额"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ row.amount && row.amount && row.amount.refundAmount }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人姓名"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.name }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="联系人手机号"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          {{ row.basic && row.basic.contact && row.basic.contact.tel }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="支付方式"
        show-overflow-tooltip
        :formatter="formatChannel"
      />
      <el-table-column
        align="left"
        label="订单状态"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag type="primary" v-if="row.step==1">待付款</el-tag>
          <el-tag type="success" v-if="row.step==2">已付款</el-tag>
          <el-tag type="warning" v-if="row.step==3">{{row.typehood === 2 ? '待注册' : '待收货'}}</el-tag>
          <el-tag type="warning" v-if="row.step==4">{{row.typehood === 2 ? '已完成' : '已核销'}}</el-tag>
          <el-tag type="danger" v-if="row.step==5">已退款</el-tag>
          <el-tag type="info" v-if="row.step==6">已取消</el-tag>
          <el-tag type="warning" v-if="row.step==8">退款中</el-tag>
          <el-tag type="warning" v-if="row.step==9">待确认</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        width="160"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="80px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleShow(row)">详情</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <ProductDetail ref="product" @fetch-data="fetchData" />
    <ApartmentDetail ref="apartment" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { getOrderList } from '@/api/order'
import { orderTypehoods, orderChannels, orderChannelOptions, orderSteps, orderTypehood } from '@/utils/const'
import ProductDetail from '../products/detail.vue'
import ApartmentDetail from '../apartment/detail.vue'
export default {
  name: 'List',
  components: { ProductDetail, ApartmentDetail },
  data() {
    return {
      moment,
      typehoods: orderTypehoods,
      channels: orderChannelOptions,
      options: orderSteps,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        step: '',
        channel: '',
        typehood: '',
        date: null,
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/order/list') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleShow(row){
      const key = orderTypehoods.find(e => e.value == row.typehood).key
      this.$refs[`${key}`].show(row)
    },
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = row && row.payment && row.payment.channel || 'UNKOWN'
      return orderChannels[channel]
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      if (this.queryForm.date) {
        this.queryForm.startDate = this.queryForm.date[0]
        this.queryForm.endDate = this.queryForm.date[1]
        this.queryForm.periodMode = 1
      } else {
        this.queryForm.startDate = ''
        this.queryForm.endDate = ''
      }
      const { list, total } = await getOrderList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.vab-query-form {
  :deep() {
    .el-form-item + .el-form-item {
      margin: 0 0 10px 10px !important;

      .el-button {
        margin: 0 0 0 0 !important;
      }
    }
  }
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
